import apiClient from "@/api/client";

/**
 * Publiczna rezygnacja z kontaktu — POZA klientem z JWT.
 *
 * Gołe `fetch`, żeby nie dotknął tego interceptor odświeżający token: po drugiej
 * stronie jest ktoś, kto w naszym systemie nie ma konta i nigdy nie będzie miał,
 * a 401 z odświeżania wywaliłby mu stronę zamiast wypisać go z wysyłki.
 */
const BASE = () => `${apiClient.defaults.baseURL ?? "/api/v1"}/leads/unsubscribe`;

export type UnsubscribeInfo = {
  company: string;
  email: string;
  already: boolean;
};

async function call<T>(token: string, method: "GET" | "POST"): Promise<T> {
  const res = await fetch(`${BASE()}/${encodeURIComponent(token)}/`, {
    method,
    headers: { "Content-Type": "application/json" },
  });
  const body = await res.json().catch(() => null);
  if (!res.ok) {
    const err = new Error(
      typeof body?.errors === "string" ? body.errors : `HTTP ${res.status}`,
    ) as Error & { status?: number };
    err.status = res.status;
    throw err;
  }
  return body?.data as T;
}

export const getUnsubscribeInfo = (token: string) =>
  call<UnsubscribeInfo>(token, "GET");

export const confirmUnsubscribe = (token: string) =>
  call<UnsubscribeInfo>(token, "POST");
